export interface IWaitListImportColumnMapping {
    fieldName: string,
    fieldFromFile: string,
    isRequired: boolean
}